module.exports = __webpack_public_path__ + "static/media/richard-cv-fr.5065bd40.pdf";